import { faPlay, faStop } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default function debugMode(option) {
    return (
        <div data-cy="historic-lpSensor-graphics">
            <span>
                ID: {option.id} -
                <FontAwesomeIcon
                    icon={option.activDebug ? faPlay : faStop}
                    color={option.activDebug ? 'green' : 'red'}
                    className="margin-left-5"
                />
            </span>
        </div>
    );
}
